module.exports = __webpack_public_path__ + "static/media/alert_icon.ff78e2c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/alert_icon.png
// module id = 1080
// module chunks = 0